const BooksTypes = {
  SET_BOOKS_LOADING: 'BOOKS/SET_BOOKS_LOADING',
  SET_BOOKS_FAILURE: 'BOOKS/SET_BOOKS_FAILURE',
  SET_BOOKS_SUCCESS: 'BOOKS/SET_BOOKS_SUCCESS',
};

export default BooksTypes;